type Prop = {
    className? : string,
    width? : string,
    containerClassName? : string,
    children ?: JSX.Element[] | JSX.Element
    override ?: boolean,
}
const AspectRatioDiv = ({
    className = '',
    containerClassName = '',
    width = '100%',
    override = false,
    children
    }:Prop)=>{
    return (
        <div style={{width}} className={containerClassName}>
            <div className={!override ? ("w-full h-0 relative " + className) : className}>
                <div className="absolute w-full h-full top-0 left-0">
                    <div className=" relative w-full h-full">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AspectRatioDiv;